import { defineComponent, computed, openBlock, createBlock, resolveDynamicComponent, mergeProps, withCtx, createVNode, normalizeClass, renderSlot, createTextVNode, createCommentVNode } from 'vue';
import _sfc_main$1 from '../../atomes/Icons/IdfIcon.vue.mjs';
import '../../IdfButton.vue_vue_type_style_index_0_scoped_8e6ae260_lang.css';import IdfTextIcon from '../IdfTextIcon/IdfTextIcon.vue.mjs';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "IdfButton",
  props: {
    disabled: { type: Boolean, default: false },
    href: {},
    iconLeft: {},
    iconRight: {},
    isLoading: { type: Boolean, default: false },
    isSuccess: { type: Boolean, default: false },
    kind: { default: "primary" },
    route: {},
    tag: { default: "button" },
    target: {}
  },
  setup(__props) {
    const props = __props;
    const linkAttribute = computed(() => {
      const { href, tag, route: to } = props;
      if (typeof tag !== "string") {
        return ["NuxtLink", "RouterLink"].includes(tag.name || "") ? { to } : {};
      }
      return {
        ...tag === "a" && { href },
        ...["nuxt-link", "router-link"].includes(tag) && { to }
      };
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), mergeProps(linkAttribute.value, {
        class: { "idf-button": true, [`is-${__props.kind}`]: true, "idf-button--prevent-click": __props.isLoading || __props.isSuccess },
        disabled: __props.disabled || __props.isLoading || __props.isSuccess ? true : void 0,
        target: __props.target
      }), {
        default: withCtx(() => [
          createVNode(IdfTextIcon, {
            class: normalizeClass({ "idf-button__text--hidden": __props.isLoading || __props.isSuccess }),
            "has-icon-css-color-vars": true,
            "icon-left": __props.iconLeft,
            "icon-right": __props.iconRight
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "default", {}, void 0, true)
            ]),
            _: 3
          }, 8, ["class", "icon-left", "icon-right"]),
          _cache[0] || (_cache[0] = createTextVNode()),
          __props.isSuccess ? (openBlock(), createBlock(_sfc_main$1, {
            key: 0,
            "has-css-color-vars": true,
            kind: "check",
            class: "idf-button__check"
          })) : __props.isLoading ? (openBlock(), createBlock(_sfc_main$1, {
            key: 1,
            "has-css-color-vars": true,
            kind: "inprogress",
            class: "idf-button__loader"
          })) : createCommentVNode("", true)
        ]),
        _: 3
      }, 16, ["class", "disabled", "target"]);
    };
  }
});

export { _sfc_main as default };
